import { render } from "./NewInfoCard.vue?vue&type=template&id=c90ace08&scoped=true"
import script from "./NewInfoCard.vue?vue&type=script&lang=js"
export * from "./NewInfoCard.vue?vue&type=script&lang=js"

import "./NewInfoCard.vue?vue&type=style&index=0&id=c90ace08&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c90ace08"]])

export default __exports__